let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1wnwY")).then(() => parcelRequire('dESiv'));